import { render, staticRenderFns } from "./PainelDeConfiguracao.vue?vue&type=template&id=2fb968dd"
import script from "./PainelDeConfiguracao.vue?vue&type=script&lang=js"
export * from "./PainelDeConfiguracao.vue?vue&type=script&lang=js"
import style0 from "./PainelDeConfiguracao.vue?vue&type=style&index=0&id=2fb968dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports